import React from "react";
import "../../index.css";
import displayPicture from "../../img/displayPicture.png";
import { HashLink as Link } from "react-router-hash-link";

function Hero() {
  return (
    <div className="firstSection flex flex-col px-5 py-20 gap-y-8 md:px-10 lg:px-20 lg:h-screen lg:justify-center">
      <div class="firstSectionHeader flex flex-col gap-y-5 lg:gap-y-8">
        <img
          class="displayPicture w-24 md:w-40"
          src={displayPicture}
          alt="displayPicture"
        ></img>
        <h1 class="introduction text-subhead md:text-header font-semibold">
          A UX designer passionate in interaction design based on Jakarta,
          Indonesia 🇮🇩
        </h1>
      </div>
      <h2 class="description text-body md:text-subhead font-light">
        <p>Hi I'm Rizqy Fachri Muhammad.</p>
        <p>
          I started as a mining engineer, but somehow I ended up being a UX
          designer. I also working on front-end development project because it's
          also quite fun for me.
        </p>
        <p>
          I’m currently working{" "}
          <a
            href="https://kudoku.id/"
            target="_blank"
            class="link text-link text-decoration-line:none"
            rel="noopener noreferrer"
          >
            @Kudoku 📱
          </a>
        </p>

        <br />
      </h2>
      <div class="accounts flex gap-x-8">
        <Link
          className="primaryButton bg-button text-body text-white"
          to="/Works"
        >
          View work
        </Link>
        <Link className="secondaryButton text-body" to="/About">
          About me
        </Link>
      </div>
    </div>
  );
}

export default Hero;
